import React from 'react'
import classNames from 'classnames'

function IconChevron({modifierClasses = []}) {
  const classes = classNames(
    'icon',
    'icon--chevron',
    'u-ml-0',
    'u-mr-0',
    modifierClasses
  )

  return (
    <svg role="presentation" aria-hidden="true" className={classes}>
      <use xlinkHref="#icon-chevron" />
    </svg>
  )
}

export default IconChevron
